import {
  Box,
  Collapse,
  Divider,
  FormControlLabel,
  Grid,
  Switch,
  TextField,
  Typography,
} from "@mui/material";
import { PeopleOutline } from "@mui/icons-material";
import InputMask from "react-input-mask";
import { removeMask } from "../../../../../../utils/masks";
import EscalationContactsSection from "./EscalationContactsSection";

// Seção "Parceiro Last Mile" (nome/contato do parceiro + contatos de escalonamento,
// que renderiza dentro do mesmo Collapse). Puramente apresentacional (sem estado
// próprio) — extraído de circuito/index.js (etapa 19, passo 3, do plano de
// melhorias), mesmo JSX/comportamento, só movido de arquivo.
export default function ParceiroUltimaMilhaSection({
  styles,
  formData,
  editMode,
  loading,
  handleNestedChange,
  showAllContacts,
  setShowAllContacts,
  handleAddContatoEscalacao,
  handleContatoEscalacaoChange,
  handleRemoveContatoEscalacao,
}) {
  return (
    <>
      <Grid item xs={12}>
        <Divider />
      </Grid>
      <Grid item xs={12}>
        <Box sx={{ ...styles.boxRow, gap: 2 }}>
          <Box sx={styles.titleWithConfig}>
            <PeopleOutline color="primary" />
            <Typography variant="mySubtitle2">Parceiro Last Mile</Typography>
          </Box>
          <FormControlLabel
            disabled={!editMode || loading}
            control={
              <Switch
                size="small"
                checked={formData?.lastMilePartner?.partnerEnabled}
                onChange={(e) =>
                  handleNestedChange(
                    "lastMilePartner",
                    "partnerEnabled",
                    e.target.checked,
                  )
                }
                name="lastMilePartner.partnerEnabled"
              />
            }
            label={null}
          />
        </Box>
      </Grid>
      {/* <Grid container spacing={1} sx={styles.contentIdentation}> */}
      <Grid
        item
        xs={12}
        sx={{ my: formData?.lastMilePartner?.partnerEnabled ? 0 : -1 }}
      >
        <Collapse
          sx={{
            ...styles.colapse,
          }}
          in={formData?.lastMilePartner?.partnerEnabled}
        >
          <Grid container spacing={1}>
            <Grid container spacing={1} sx={styles.contentIdentation}>
              <Grid item xs={12} sm={6}>
                <TextField
                  sx={styles.textField}
                  disabled={!editMode || loading}
                  autoComplete="off"
                  fullWidth
                  size="small"
                  label="Nome do parceiro"
                  value={formData?.lastMilePartner?.partnerName}
                  onChange={(e) =>
                    handleNestedChange(
                      "lastMilePartner",
                      "partnerName",
                      e?.target?.value,
                    )
                  }
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <InputMask
                  mask={
                    removeMask(formData?.lastMilePartner?.partnerContact)
                      ?.length <= 10
                      ? "(99) 9999-99999"
                      : "(99) 99999-9999"
                  }
                  value={formData?.lastMilePartner?.partnerContact}
                  onChange={(e) =>
                    handleNestedChange(
                      "lastMilePartner",
                      "partnerContact",
                      removeMask(e?.target?.value),
                    )
                  }
                  maskChar=""
                  disabled={!editMode || loading}
                >
                  {(props) => (
                    <TextField
                      sx={styles.textField}
                      disabled={!editMode || loading}
                      autoComplete="off"
                      {...props}
                      fullWidth
                      size="small"
                      label="Contato do parceiro"
                    />
                  )}
                </InputMask>
              </Grid>
            </Grid>
            <EscalationContactsSection
              styles={styles}
              formData={formData}
              editMode={editMode}
              loading={loading}
              showAllContacts={showAllContacts}
              setShowAllContacts={setShowAllContacts}
              handleAddContatoEscalacao={handleAddContatoEscalacao}
              handleContatoEscalacaoChange={handleContatoEscalacaoChange}
              handleRemoveContatoEscalacao={handleRemoveContatoEscalacao}
            />
          </Grid>
        </Collapse>
      </Grid>
      {/* </Grid> */}
      <Grid item xs={12}>
        <Divider />
      </Grid>
    </>
  );
}
